import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Tab, Nav, Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { AuthContext } from '../context/AuthContext';
import useApi from "../hooks/useApi";
import ForgotPasswordModal from "./ForgotPasswordModal";

const LoginModal = ({ show, onClose, onRegisterClick = () => {} }) => {
  const [activeTab, setActiveTab] = useState("email");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const navigate = useNavigate();
  const { loginUser, saveAuthToken, setViewMode } = useContext(AuthContext);
  const { publicAuth } = useApi();

  useEffect(() => {
    if (show) {
      resetForm();
      // Prevent scrolling when modal is open
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "15px"; // Prevent content shift from scrollbar
    } else {
      // Restore scrolling when modal is closed
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }

    // Cleanup function
    return () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [show]);

  const resetForm = () => {
    setEmail("");
    setContact("");
    setPassword("");
    setShowPassword(false);
    setErrors({});
    setIsLoading(false);
    setActiveTab("email");
  };

  const validate = () => {
    const newErrors = {};

    if (activeTab === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email.trim()) newErrors.email = "Email is required";
      else if (!emailRegex.test(email)) newErrors.email = "Enter a valid email";
    } else {
      const phoneRegex = /^[0-9]{10}$/;
      if (!contact.trim()) newErrors.contact = "Phone number is required";
      else if (!phoneRegex.test(contact)) newErrors.contact = "Enter 10-digit phone number";
    }

    if (!password.trim()) newErrors.password = "Password is required";
    else if (password.length < 4) newErrors.password = "Minimum 4 characters";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsLoading(true);
    try {
      const payload = {
        password,
        ...(activeTab === "email" ? { email } : { contact }),
      };

      const response = await publicAuth(`login`,"POST", payload);
      if (response.data.status === true) {
        const user = response.data.data; 

        loginUser(user);
        setViewMode("user");
        saveAuthToken(response.data.token);
        onClose();
        navigate("/dashboard/dashboard");
      } else {
        let alertConfig = {
          icon: "error",
          title: "Login Failed",
          text: response.data.message || "Invalid credentials",
        };

        if (response.data.message === "admin approval pending" || response.data.message === "asysta approval pending") {
          alertConfig = {
            icon: "warning",
            title: "Approval Pending",
            text: "Your account is under Asysta team review.",
            footer: "Please contact Asysta support for assistance",
          };
        }

        Swal.fire(alertConfig);
      }
    } catch (error) {
      console.error("Login error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Something went wrong.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Forgot password modal खुलने पर login modal को disable करें
  const handleForgotClick = () => {
    setShowForgot(true);
  };

  const handleForgotClose = () => {
    setShowForgot(false);
  };

  if (!show) return null;

  return (
    <>
      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1050;
          overflow-y: auto;
          padding: 20px;
          transition: all 0.3s ease;
        }
        
        .modal-overlay.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
        
        .modal-box {
          background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
          border-radius: 15px;
          padding: 30px;
          width: 100%;
          max-width: 450px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.2);
          position: relative;
          overflow: hidden;
          margin: auto;
          transition: all 0.3s ease;
        }
        
        .modal-box.disabled {
          filter: blur(2px);
        }
        
        .modal-box::before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 120px;
          background-image: url('${process.env.PUBLIC_URL}/assets/images/logincar.png');
          background-size: contain;
          background-position: center bottom;
          background-repeat: no-repeat;
          opacity: 0.15;
          z-index: 0;
        }
        .loginclose {
          position: absolute;
          top: 15px;
          right: 20px;
          font-size: 1.5rem;
          background: none;
          border: none;
          cursor: pointer;
          color: #6c757d;
          transition: color 0.2s;
          z-index: 1;
        }
        .loginclose:hover {
          color: #495057;
        }
        .loginclose.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
        .modal-content {
          position: relative;
          z-index: 1;
        }
        .nav-tabs {
          border-bottom: 2px solid #dee2e6;
          margin-bottom: 20px;
        }
        .nav-tabs .nav-link {
          border: none;
          color: #6c757d;
          font-weight: 500;
          padding: 10px 15px;
          margin-right: 5px;
        }
        .nav-tabs .nav-link.active {
          color: #0d6efd;
          background-color: transparent;
          border-bottom: 2px solid #0d6efd;
        }
        .nav-tabs .nav-link.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
        .form-control {
          border-radius: 8px;
          padding: 12px 15px;
          border: 1px solid #ced4da;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .form-control:focus {
          border-color: #86b7fe;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }
        .form-control.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
        .btn-primary {
          background-color: #0d6efd;
          border: none;
          border-radius: 8px;
          padding: 12px;
          font-weight: 500;
          transition: background-color 0.2s;
        }
        .btn-primary:hover {
          background-color: #0b5ed7;
        }
        .btn-primary.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
        .text-danger {
          font-size: 0.85rem;
          margin-top: 5px;
        }
        .password-input-group {
          position: relative;
        }
        .password-toggle {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          color: #6c757d;
          background: none;
          border: none;
          padding: 0;
        }
        .password-toggle:hover {
          color: #495057;
        }
        .password-toggle.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
        .forgot-password-btn {
          background: none;
          border: none;
          color: #0d6efd;
          padding: 0;
          text-decoration: underline;
          cursor: pointer;
          font-size: 0.9rem;
        }
        .forgot-password-btn:hover {
          color: #0b5ed7;
        }
        .forgot-password-btn.disabled {
          pointer-events: none;
          opacity: 0.5;
        }

        /* Responsive adjustments */
        @media (max-width: 576px) {
          .modal-box {
            padding: 20px;
            max-width: 95%;
          }
          .nav-tabs .nav-link {
            padding: 8px 10px;
            font-size: 14px;
          }
          .form-control {
            padding: 10px 12px;
          }
          .btn-primary {
            padding: 10px;
          }
        }
      `}</style>

      {/* Forgot Password Modal - अलग layer में */}
      <ForgotPasswordModal
        show={showForgot}
        handleClose={handleForgotClose}
      />

      {/* Login Modal */}
      <div className={`modal-overlay ${showForgot ? 'disabled' : ''}`}>
        <div className={`modal-box ${showForgot ? 'disabled' : ''}`}>
          <button 
            onClick={onClose} 
            className={`loginclose ${showForgot ? 'disabled' : ''}`} 
            aria-label="Close login modal"
            disabled={showForgot}
          >
            &times;
          </button>

          <div className="modal-content">
            <h2 className="text-center mb-4" style={{ color: '#343a40' }}>Welcome Back!</h2>
            <p className="text-center text-muted mb-4">Please login to continue</p>

            <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
              <Nav variant="tabs" className="justify-content-center">
                <Nav.Item>
                  <Nav.Link 
                    eventKey="phone" 
                    className={showForgot ? 'disabled' : ''}
                    disabled={showForgot}
                  >
                    Phone Login
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link 
                    eventKey="email" 
                    className={showForgot ? 'disabled' : ''}
                    disabled={showForgot}
                  >
                    Email Login
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="phone">
                  <form onSubmit={handleLogin} className="mt-3">
                    <div className="form-group mb-3">
                      <input
                        type="text"
                        className={`form-control ${errors.contact ? "is-invalid" : ""} ${showForgot ? 'disabled' : ''}`}
                        placeholder="Phone Number*"
                        value={contact}
                        onChange={(e) => {
                          setContact(e.target.value);
                          setErrors((prev) => ({ ...prev, contact: "" }));
                        }}
                        disabled={isLoading || showForgot}
                      />
                      {errors.contact && (
                        <div className="text-danger">{errors.contact}</div>
                      )}
                    </div>

                    <div className="form-group mb-3">
                      <div className="password-input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className={`form-control ${errors.password ? "is-invalid" : ""} ${showForgot ? 'disabled' : ''}`}
                          placeholder="Password*"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            setErrors((prev) => ({ ...prev, password: "" }));
                          }}
                          disabled={isLoading || showForgot}
                          style={{ paddingRight: "40px" }}
                        />
                        <button
                          type="button"
                          className={`password-toggle ${showForgot ? 'disabled' : ''}`}
                          onClick={() => setShowPassword(!showPassword)}
                          disabled={isLoading || showForgot}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                      {errors.password && (
                        <div className="text-danger">{errors.password}</div>
                      )}
                    </div>

                    <button
                      type="submit"
                      className={`btn btn-primary w-100 mt-2 ${showForgot ? 'disabled' : ''}`}
                      disabled={isLoading || showForgot}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Logging in...
                        </>
                      ) : (
                        "Login with Phone"
                      )}
                    </button>
                  </form>
                </Tab.Pane>

                <Tab.Pane eventKey="email">
                  <form onSubmit={handleLogin} className="mt-3">
                    <div className="form-group mb-3">
                      <input
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""} ${showForgot ? 'disabled' : ''}`}
                        placeholder="Email Address*"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setErrors((prev) => ({ ...prev, email: "" }));
                        }}
                        disabled={isLoading || showForgot}
                      />
                      {errors.email && (
                        <div className="text-danger">{errors.email}</div>
                      )}
                    </div>

                    <div className="form-group mb-3">
                      <div className="password-input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className={`form-control ${errors.password ? "is-invalid" : ""} ${showForgot ? 'disabled' : ''}`}
                          placeholder="Password*"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            setErrors((prev) => ({ ...prev, password: "" }));
                          }}
                          disabled={isLoading || showForgot}
                          style={{ paddingRight: "40px" }}
                        />
                        <button
                          type="button"
                          className={`password-toggle ${showForgot ? 'disabled' : ''}`}
                          onClick={() => setShowPassword(!showPassword)}
                          disabled={isLoading || showForgot}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                      {errors.password && (
                        <div className="text-danger">{errors.password}</div>
                      )}
                    </div>

                    <button
                      type="submit"
                      className={`btn btn-primary w-100 mt-2 ${showForgot ? 'disabled' : ''}`}
                      disabled={isLoading || showForgot}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Logging in...
                        </>
                      ) : (
                        "Login with Email"
                      )}
                    </button>
                    
                    <div className="text-center mt-3">
                      <button
                        type="button"
                        className={`forgot-password-btn ${showForgot ? 'disabled' : ''}`}
                        onClick={handleForgotClick}
                        disabled={showForgot}
                      >
                        Forgot Password?
                      </button>
                    </div>
                  </form>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>

            <div className="text-center mt-4">
              <p className="text-muted mb-2" style={{ fontSize: "14px" }}>
                New to our platform?{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (!showForgot) onRegisterClick();
                  }}
                  style={{ 
                    color: "#0d6efd", 
                    fontWeight: "500",
                    pointerEvents: showForgot ? 'none' : 'auto',
                    opacity: showForgot ? 0.5 : 1
                  }}
                >
                  Register Now
                </a>
              </p>
              <p className="text-muted" style={{ fontSize: "12px" }}>
                By logging in, you agree to our Terms and Privacy Policy
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginModal;
